import { put } from 'redux-saga/effects';
import axios from 'src/api/Api';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { GET_VIEWFILTER_SUCCESS, GET_VIEWFILTER_FAILURE } from '../actions';
import { convertObjectToQueryParams } from 'src/utils/util';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
export default function* getViewFilter(action) {
    const params = convertObjectToQueryParams({ ...action.payload });
    const url = `/occ/v2/${localStorage.getItem('baseSiteId')}/orders/filter?${params}`;
    try {
        const result = yield axios.get(url).then((response) => response.data);

        yield put({ type: GET_VIEWFILTER_SUCCESS, data: result });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload,
        });
        yield put({
            type: GET_VIEWFILTER_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
